<template>
  <a-spin :spinning="confirmLoading">
    <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
      <a-row>
        <a-col :span="24">
          <a-form-model-item label="序号" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="orderNo">
            <a-input v-model="model.orderNo" placeholder="请输入序号"></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="报告名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="reportName">
            <a-input v-model="model.reportName" placeholder="请输入报告名称"></a-input>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="报告状态" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="reportStatus">
            <j-dict-select-tag type="radio" v-model="model.reportStatus" dictCode="" placeholder="请选择报告状态" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="负责人" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="manager">
            <j-dict-select-tag type="list" v-model="model.manager" dictCode="" placeholder="请选择负责人" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="事件描述" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="description">
            <a-textarea v-model="model.description" rows="4" placeholder="请输入事件描述" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="可能原因" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="possibleCause">
            <a-textarea v-model="model.possibleCause" rows="4" placeholder="请输入可能原因" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="处理建议" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="suggest">
            <a-textarea v-model="model.suggest" rows="4" placeholder="请输入处理建议" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="现场反馈" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="feedback">
            <a-textarea v-model="model.feedback" rows="4" placeholder="请输入现场反馈" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="是否有效告警" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="effective">
            <j-dict-select-tag type="radio" v-model="model.effective" dictCode="" placeholder="请选择是否有效告警" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="影响程度" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="impact">
            <a-textarea v-model="model.impact" rows="4" placeholder="请输入影响程度" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-spin>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'

export default {
  name: 'IotModelEventReportForm',
  components: {},
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {
        reportName: [{ required: true, message: '请输入报告名称!' }],
        manager: [{ required: true, message: '请输入负责人!' }],
        description: [{ required: true, message: '请输入事件描述!' }]
      },
      url: {
        add: '/org.jeecg.modules.monitor/iotModelEventReport/add',
        edit: '/org.jeecg.modules.monitor/iotModelEventReport/edit',
        queryById: '/org.jeecg.modules.monitor/iotModelEventReport/queryById'
      }
    }
  },
  computed: {
    formDisabled() {
      return this.disabled
    }
  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model))
  },
  methods: {
    add() {
      this.edit(this.modelDefault)
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
    },
    submitForm() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          httpAction(httpurl, this.model, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    }
  }
}
</script>
